export type TransportResult = {
    data: any;
    statusCode: number;
}

export class TransportError extends Error {
    statusCode: number;

    constructor(message: string, statusCode: number) {
        super(message);
        this.statusCode = statusCode;
    }
}

export class DataTransporter {
    public async get(url: string): Promise<TransportResult> {
        const method = "GET";
        const response = await fetch(
            url,
            {
                headers: {
                    Accept: "application/json",
                },
                method: method,
                credentials: "include",
            }
        );

        return await DataTransporter.processResponse(method, response);
    }

    public async post(url: string, payload: any): Promise<TransportResult> {
        const method = "POST";
        const response = await fetch(
            url,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                method: method,
                body: JSON.stringify(payload),
                credentials: "include",
            }
        );

        return await DataTransporter.processResponse(method, response);
    }

    public async put(url: string, payload: any): Promise<TransportResult> {
        const method = "PUT";
        const response = await fetch(
            url,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                method: method,
                body: JSON.stringify(payload),
                credentials: "include",
            }
        );

        return await DataTransporter.processResponse(method, response);
    }

    public async patch(url: string, payload: any): Promise<TransportResult> {
        const method = "PATCH";
        const response = await fetch(
            url,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                method: "PATCH",
                body: payload,
                credentials: "include",
            }
        );

        return await DataTransporter.processResponse(method, response);
    }

    public async delete(url: string): Promise<TransportResult> {
        const method = "DELETE";
        const response = await fetch(
            url,
            {
                headers: {
                    Accept: "application/json",
                },
                method: method,

                credentials: "include",
            }
        );

        return await DataTransporter.processResponse(method, response)
    }

    private static async processResponse(requestMethod: string, response: Response): Promise<TransportResult> {
        const statusCode = response.status;

        if (response.ok) {
            try {
                const data = await response.json();
                return { data, statusCode };
            } catch {
                return { data: undefined, statusCode }
            }
        }

        throw new TransportError(`${requestMethod} ${response.url} failed with status code ${response.status}`, statusCode);
    }
}
